import {Component, OnInit, Input, Output, EventEmitter, ViewChild, DestroyRef, inject} from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MenuStoreService } from '@emm/menu/services/menu-store.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {MenuChange} from '@emm/core/models/menu-change.model';
import {AuthFacadeService} from '@emm/auth/services/auth-facade.service';
import {ChangeSetService} from '@emm/core/services/change-set.service';
import {FeatureScope} from '@emm/core/util/feature-scope.constants';
import {ChangeSet} from '@emm/core/models/change-set.model';

@Component({
    selector: 'emm-change-set',
    styleUrls: ['./change-set.component.scss'],
    templateUrl: './change-set.component.html'
})
export class ChangeSetComponent implements OnInit {

    private readonly destroyRef: DestroyRef = inject(DestroyRef);

    isReadOnly$ = this.authFacade.isReadOnly$;
    isReadOnlyScope: boolean;
    pageEvent: PageEvent;
    pageSize = 5;
    changes: MenuChange[];
    effectiveDate;
    consumerOrSubmenu;

    @Input() lastChange;
    @Input() changeCount: number;
    @Input() changeSet: ChangeSet;
    @Input() featureScope: string;
    @Input() selectedConsumer: string;
    @Input() selectedLocation: string;
    @Input() selectedSubmenu: string;

    @Output() updatedName = new EventEmitter<string>();

    @ViewChild('paginator') paginator: MatPaginator;

    constructor(
        private authFacade: AuthFacadeService,
        private changeSetService: ChangeSetService,
        private menuStore: MenuStoreService) {}


    ngOnInit(): void {
        this.menuStore.queryBase.effectiveDate$
            .pipe(
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe(result => this.effectiveDate = result);
        switch (this.featureScope) {
            case FeatureScope.Viewer:
                this.menuStore.queryConsumers.selected$
                    .pipe(
                        takeUntilDestroyed(this.destroyRef)
                    )
                    .subscribe(result => {
                    this.consumerOrSubmenu = result.tag;
                });
                break;
            case FeatureScope.Global:
            case FeatureScope.Client:
                this.menuStore.querySubmenus.selected$
                    .pipe(
                        takeUntilDestroyed(this.destroyRef)
                    )
                    .subscribe(result => {
                    this.consumerOrSubmenu = result;
                });
                break;
        }
        this.loadChanges();
        this.isReadOnlyScope = this.featureScope === FeatureScope.Client ||
            this.featureScope === FeatureScope.Viewer;
    }



    loadChanges(): void {
        this.getChangesV4(this.featureScope, this.consumerOrSubmenu, this.changeSet.effectiveDate,
            this.selectedLocation, 0, this.pageSize);
        this.paginator?.firstPage();
    }



    page($event: PageEvent): void {
        this.pageEvent = $event;
        this.getChangesV4(this.featureScope, this.consumerOrSubmenu, this.changeSet.effectiveDate,
            this.selectedLocation, this.pageEvent.pageIndex, this.pageEvent.pageSize)
    }


    getChangesV4(featureScope: string, submenu: string, date: string, location: string, pageIndex: number,
                 pageSize: number) {
        this.changeSetService.getChangeSetChangesV4(featureScope, submenu, date, location, pageIndex, pageSize)
            .pipe(
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe(
            res => {
                for (const change of res) {
                    const temp = change.commandClass.split('.');
                    change.commandClass = temp[temp.length - 1];
                }
                this.changes = res;
            });
    }
}
